<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">اسم الدولة</h5>

                       <span> بالرجاء ملئ جميع الحقول </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form class="needs-validation" autocomplete="off" 
                    [formGroup] = "countryForm"
                    (ngSubmit)="onSubmit()" 
                    novalidate>
                        <div class="form-row">
                            <!-- title  -->
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> اسم الدولة</label>
                                <input class="form-control"  id="validation01" type="text" formControlName="TitleAr"
                                [tooltip]="fc.TitleAr.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.TitleAr.valid && (fc.TitleAr.touched)"
                                [class.is-invalid]="fc.TitleAr.invalid && (fc.TitleAr.touched)"
                             
                                     required
                                     placeholder="الأسم"
                                    containerClass="" />
                            </div>
                            <!-- <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> اسم الدولة باللغه الانجليزية</label>
                                <input class="form-control" appDisableWeritingArabic id="validation01" type="text" formControlName="Title"
                                [tooltip]="fc.Title.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.Title.valid && (fc.Title.touched)"
                                [class.is-invalid]="fc.Title.invalid && (fc.Title.touched)"
                             
                                     required
                                     placeholder="الأسم"
                                    containerClass="" />
                            </div> -->
                      </div>
                   
                        <ng-template #elseBlock>
                            <button [disabled]="button" class="btn pull-right" type="submit">
                               حفظ
                            </button>
                            </ng-template>
                        <div *ngIf="update; else elseBlock">
                            <button class="btn pull-right" type="submit">
                                تعديل
                            </button>
                       </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

